export default __webpack_public_path__ + "static/media/399.7aa54b77.jpg";